import React, { useState } from "react";
import { StyleSheet, View, Platform } from "react-native";

import AppTheme from "../../AppTheme";
import { buttonStyle } from "../../common/ActionsMenuButton/utils";
import { openURL, getContactMailUrl } from "../../../../helpers/utils";

import ActionButton from "../../common/ActionsMenuButton/ActionButton";
import InviteIcon from "../../common/ActionsMenuButton/icons/InviteIcon";
import NewElementIcon from "../../common/ActionsMenuButton/icons/NewElementIcon";
import ScaleIcon from "../../common/ActionsMenuButton/icons/ScaleIcon";

export default function ComparisonFabButton(props) {
  const { showEditSetsView, style, mariOptions = {} } = props;
  const [actionButton, setActionButton] = useState(null);

  const actions = [
    <ActionButton.Item
      key={1}
      underline={true}
      hideShadow
      buttonColor="#FFF"
      title="Ask Us Anything"
      onPress={() => {
        openURL(getContactMailUrl());
      }}
    >
      <InviteIcon style={styles.actionButtonIcon} />
    </ActionButton.Item>,
  ];

  if (showEditSetsView) {
    actions.push(
      <ActionButton.Item
        key={2}
        hideShadow
        noBorder
        buttonColor="#FFF"
        title="Customize Comparisons"
        onPress={showEditSetsView}
      >
        <ScaleIcon />
      </ActionButton.Item>,
    );
  }

  return (
    <View
      style={[buttonStyle, style]}
      onLayout={(event) => {
        if (actionButton != null)
          actionButton.setParentLayout(event.nativeEvent.layout);
      }}
    >
      <ActionButton
        mariOptions={mariOptions}
        ref={(r) => setActionButton(r)}
        buttonColor={AppTheme.DEFAULT_COLOR}
        zIndex={999}
        source={"ComparisonFabButton"}
        //buttonTextStyle={styles.mainButton}
      >
        {actions}
      </ActionButton>
    </View>
  );
}

const styles = StyleSheet.create({
  mainButton: {
    fontSize: 44,
    height: 58,
    marginTop: -5,
    fontWeight: "200",
    fontFamily: Platform.select({
      default: "Nunito",
      android: "Nunito-Regular",
    }),
  },
  actionButtonIcon: {
    marginTop: 5,
    width: 44,
    height: 44,
  },
});
